module.exports = __webpack_public_path__ + "static/media/cucumber.4b6564cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/toppings/cucumber.jpg
// module id = 126
// module chunks = 0